import './styles.scss';
import './styles/favicon.ico';
import './styles/logo.png';


// WEBPACK FOOTER //
// ./src/styles.js